import React, { useEffect, useRef, useState } from 'react';

import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import useSettings from '../../hooks/useSettings';
import useCompanies from '../../hooks/useCompanies';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { makeStyles } from '@material-ui/core/styles';
import { grey, blue } from '@material-ui/core/colors';
import { Tabs, Tab } from '@material-ui/core';
import { i18n } from '../../translate/i18n';

//import 'react-toastify/dist/ReactToastify.css';

const useStyles = makeStyles(theme => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    height: 240,
  },
  tab: {
    backgroundColor: theme.palette.options, //DARK MODE PLW DESIGN//
    borderRadius: 4,
    width: '100%',
    '& .MuiTab-wrapper': {
      color: theme.palette.fontecor,
    }, //DARK MODE PLW DESIGN//
    '& .MuiTabs-flexContainer': {
      justifyContent: 'center',
    },
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    marginBottom: 12,
    width: '100%',
  },
  cardAvatar: {
    fontSize: '55px',
    color: grey[500],
    backgroundColor: '#ffffff',
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardTitle: {
    fontSize: '18px',
    color: blue[700],
  },
  cardSubtitle: {
    color: grey[600],
    fontSize: '14px',
  },
  alignRight: {
    textAlign: 'right',
  },
  fullWidth: {
    width: '100%',
  },
  selectContainer: {
    width: '100%',
    textAlign: 'left',
  },
}));

export default function Options(props) {
  const { settings, scheduleTypeChanged } = props;
  const classes = useStyles();
  const [userRating, setUserRating] = useState('disabled');
  const [scheduleType, setScheduleType] = useState('disabled');
  const [callType, setCallType] = useState('enabled');
  const [chatbotType, setChatbotType] = useState('');
  const [CheckMsgIsGroup, setCheckMsgIsGroupType] = useState('enabled');

  const [loadingUserRating, setLoadingUserRating] = useState(false);
  const [loadingScheduleType, setLoadingScheduleType] = useState(false);
  const [loadingCallType, setLoadingCallType] = useState(false);
  const [loadingChatbotType, setLoadingChatbotType] = useState(false);
  const [loadingCheckMsgIsGroup, setCheckMsgIsGroup] = useState(false);

  //const [ipixcType, setIpIxcType] = useState("");
  //const [loadingIpIxcType, setLoadingIpIxcType] = useState(false);
  //const [tokenixcType, setTokenIxcType] = useState("");
  //const [loadingTokenIxcType, setLoadingTokenIxcType] = useState(false);

  //const [ipmkauthType, setIpMkauthType] = useState("");
  //const [loadingIpMkauthType, setLoadingIpMkauthType] = useState(false);
  //const [clientidmkauthType, setClientIdMkauthType] = useState("");
  //const [loadingClientIdMkauthType, setLoadingClientIdMkauthType] = useState(false);
  //const [clientsecretmkauthType, setClientSecrectMkauthType] = useState("");
  //const [loadingClientSecrectMkauthType, setLoadingClientSecrectMkauthType] = useState(false);

  const [asaasType, setAsaasType] = useState('');
  const [loadingAsaasType, setLoadingAsaasType] = useState(false);

  // Endereço da clínica: usado para preencher a localização dos agendamentos
  const [clinicAddress, setClinicAddress] = useState('');
  const [tempClinicAddress, setTempClinicAddress] = useState('');
  const [loadingClinicAddress, setLoadingClinicAddress] = useState(false);
  // Marca se o usuário já editou o campo, para o reload de settings não
  // sobrescrever o que ele está digitando
  const clinicAddressTouchedRef = useRef(false);

  // recursos a mais da plw design

  const [SendGreetingAccepted, setSendGreetingAccepted] = useState('disabled');
  const [loadingSendGreetingAccepted, setLoadingSendGreetingAccepted] =
    useState(false);

  const [SettingsTransfTicket, setSettingsTransfTicket] = useState('disabled');
  const [loadingSettingsTransfTicket, setLoadingSettingsTransfTicket] =
    useState(false);

  const [sendGreetingMessageOneQueues, setSendGreetingMessageOneQueues] =
    useState('disabled');
  const [
    loadingSendGreetingMessageOneQueues,
    setLoadingSendGreetingMessageOneQueues,
  ] = useState(false);

  // Configuração de tempo de ociosidade
  const [idleTimeLimit, setIdleTimeLimit] = useState('60');
  const [tempIdleTimeLimit, setTempIdleTimeLimit] = useState('60');
  const [loadingIdleTimeLimit, setLoadingIdleTimeLimit] = useState(false);

  const { update } = useSettings();
  const { find: findCompany } = useCompanies();

  // Carregar idleTimeLimit da empresa
  useEffect(() => {
    const loadCompanyIdleTimeLimit = async () => {
      try {
        const companyId = localStorage.getItem('companyId');
        if (companyId) {
          const company = await findCompany(companyId);
          if (company && company.idleTimeLimit) {
            setIdleTimeLimit(company.idleTimeLimit.toString());
            setTempIdleTimeLimit(company.idleTimeLimit.toString());
          }
        }
      } catch (error) {
        console.error('Erro ao carregar idleTimeLimit da empresa:', error);
      }
    };

    loadCompanyIdleTimeLimit();
  }, []); // Array vazio para executar apenas uma vez

  useEffect(() => {
    if (Array.isArray(settings) && settings.length) {
      const userRating = settings.find(s => s.key === 'userRating');
      if (userRating) {
        setUserRating(userRating.value);
      }
      const scheduleType = settings.find(s => s.key === 'scheduleType');
      if (scheduleType) {
        setScheduleType(scheduleType.value);
      }
      const callType = settings.find(s => s.key === 'call');
      if (callType) {
        setCallType(callType.value);
      }
      const CheckMsgIsGroup = settings.find(s => s.key === 'CheckMsgIsGroup');
      if (CheckMsgIsGroup) {
        setCheckMsgIsGroupType(CheckMsgIsGroup.value);
      }

      {
        /*PLW DESIGN SAUDAÇÃO*/
      }
      const SendGreetingAccepted = settings.find(
        s => s.key === 'sendGreetingAccepted'
      );
      if (SendGreetingAccepted) {
        setSendGreetingAccepted(SendGreetingAccepted.value);
      }
      {
        /*PLW DESIGN SAUDAÇÃO*/
      }

      {
        /*TRANSFERIR TICKET*/
      }
      const SettingsTransfTicket = settings.find(
        s => s.key === 'sendMsgTransfTicket'
      );
      if (SettingsTransfTicket) {
        setSettingsTransfTicket(SettingsTransfTicket.value);
      }
      {
        /*TRANSFERIR TICKET*/
      }

      const sendGreetingMessageOneQueues = settings.find(
        s => s.key === 'sendGreetingMessageOneQueues'
      );
      if (sendGreetingMessageOneQueues) {
        setSendGreetingMessageOneQueues(sendGreetingMessageOneQueues.value);
      }

      const chatbotType = settings.find(s => s.key === 'chatBotType');
      if (chatbotType) {
        setChatbotType(chatbotType.value);
      }

      {
        /*const ipixcType = settings.find((s) => s.key === "ipixc");
      if (ipixcType) {
        setIpIxcType(ipixcType.value);
      }*/
      }

      {
        /*const tokenixcType = settings.find((s) => s.key === "tokenixc");
      if (tokenixcType) {
        setTokenIxcType(tokenixcType.value);
      }*/
      }

      {
        /*const ipmkauthType = settings.find((s) => s.key === "ipmkauth");
      if (ipmkauthType) {
        setIpMkauthType(ipmkauthType.value);
      }*/
      }

      {
        /* const clientidmkauthType = settings.find((s) => s.key === "clientidmkauth");
      if (clientidmkauthType) {
        setClientIdMkauthType(clientidmkauthType.value);
      }*/
      }

      {
        /*const clientsecretmkauthType = settings.find((s) => s.key === "clientsecretmkauth");
      if (clientsecretmkauthType) {
        setClientSecrectMkauthType(clientsecretmkauthType.value);
      }*/
      }

      const asaasType = settings.find(s => s.key === 'asaas');
      if (asaasType) {
        setAsaasType(asaasType.value);
      }

      // Carregar configuração de tempo de ociosidade
      const idleTimeLimitSetting = settings.find(
        s => s.key === 'idleTimeLimit'
      );
      if (idleTimeLimitSetting) {
        setIdleTimeLimit(idleTimeLimitSetting.value);
      }

      const clinicAddressSetting = settings.find(
        s => s.key === 'clinicAddress'
      );
      if (clinicAddressSetting) {
        setClinicAddress(clinicAddressSetting.value);
        // `settings` é recarregado (inclusive por socket ao salvar qualquer
        // outra configuração). Sem esta guarda, o recarregamento sobrescrevia
        // o que o usuário estava digitando no campo de endereço.
        if (!clinicAddressTouchedRef.current) {
          setTempClinicAddress(clinicAddressSetting.value);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings]);

  async function handleChangeUserRating(value) {
    setUserRating(value);
    setLoadingUserRating(true);
    await update({
      key: 'userRating',
      value,
    });
    toast.success(i18n.t('settings.options.toasts.success'));
    setLoadingUserRating(false);
  }

  async function handleSendGreetingMessageOneQueues(value) {
    setSendGreetingMessageOneQueues(value);
    setLoadingSendGreetingMessageOneQueues(true);
    await update({
      key: 'sendGreetingMessageOneQueues',
      value,
    });
    toast.success(i18n.t('settings.options.toasts.success'));
    setLoadingSendGreetingMessageOneQueues(false);
  }

  async function handleScheduleType(value) {
    setScheduleType(value);
    setLoadingScheduleType(true);
    await update({
      key: 'scheduleType',
      value,
    });
    //toast.success("Oraçãpeo atualizada com sucesso.");
    toast.success(i18n.t('settings.options.toasts.success'), {
      position: 'top-right',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      theme: 'light',
    });
    setLoadingScheduleType(false);
    if (typeof scheduleTypeChanged === 'function') {
      scheduleTypeChanged(value);
    }
  }

  async function handleCallType(value) {
    setCallType(value);
    setLoadingCallType(true);
    await update({
      key: 'call',
      value,
    });
    toast.success(i18n.t('settings.options.toasts.success'));
    setLoadingCallType(false);
  }

  async function handleChatbotType(value) {
    setChatbotType(value);
    setLoadingChatbotType(true);
    await update({
      key: 'chatBotType',
      value,
    });
    toast.success(i18n.t('settings.options.toasts.success'));
    setLoadingChatbotType(false);
  }

  async function handleGroupType(value) {
    setCheckMsgIsGroupType(value);
    setCheckMsgIsGroup(true);
    await update({
      key: 'CheckMsgIsGroup',
      value,
    });
    toast.success(i18n.t('settings.options.toasts.success'));
    setCheckMsgIsGroupType(false);
    /*     if (typeof scheduleTypeChanged === "function") {
          scheduleTypeChanged(value);
        } */
  }

  {
    /*NOVO CÓDIGO*/
  }
  async function handleSendGreetingAccepted(value) {
    setSendGreetingAccepted(value);
    setLoadingSendGreetingAccepted(true);
    await update({
      key: 'sendGreetingAccepted',
      value,
    });
    toast.success(i18n.t('settings.options.toasts.success'));
    setLoadingSendGreetingAccepted(false);
  }

  {
    /*NOVO CÓDIGO*/
  }

  async function handleSettingsTransfTicket(value) {
    setSettingsTransfTicket(value);
    setLoadingSettingsTransfTicket(true);
    await update({
      key: 'sendMsgTransfTicket',
      value,
    });

    toast.success(i18n.t('settings.options.toasts.success'));
    setLoadingSettingsTransfTicket(false);
  }

  {
    /*async function handleChangeIPIxc(value) {
    setIpIxcType(value);
    setLoadingIpIxcType(true);
    await update({
      key: "ipixc",
      value,
    });
    toast.success(i18n.t("settings.options.toasts.success"));
    setLoadingIpIxcType(false);
  }

   {/*async function handleChangeTokenIxc(value) {
    setTokenIxcType(value);
    setLoadingTokenIxcType(true);
    await update({
      key: "tokenixc",
      value,
    });
    toast.success(i18n.t("settings.options.toasts.success"));
    setLoadingTokenIxcType(false);
  }

  async function handleChangeIpMkauth(value) {
    setIpMkauthType(value);
    setLoadingIpMkauthType(true);
    await update({
      key: "ipmkauth",
      value,
    });
    toast.success(i18n.t("settings.options.toasts.success"));
    setLoadingIpMkauthType(false);
  }

  async function handleChangeClientIdMkauth(value) {
    setClientIdMkauthType(value);
    setLoadingClientIdMkauthType(true);
    await update({
      key: "clientidmkauth",
      value,
    });
    toast.success(i18n.t("settings.options.toasts.success"));
    setLoadingClientIdMkauthType(false);
  }

  async function handleChangeClientSecrectMkauth(value) {
    setClientSecrectMkauthType(value);
    setLoadingClientSecrectMkauthType(true);
    await update({
      key: "clientsecretmkauth",
      value,
    });
    toast.success(i18n.t("settings.options.toasts.success"));
    setLoadingClientSecrectMkauthType(false);
  }*/
  }

  async function handleChangeAsaas(value) {
    setAsaasType(value);
    setLoadingAsaasType(true);
    await update({
      key: 'asaas',
      value,
    });
    toast.success(i18n.t('settings.options.toasts.success'));
    setLoadingAsaasType(false);
  }

  async function handleSaveClinicAddress() {
    setLoadingClinicAddress(true);
    try {
      await update({
        key: 'clinicAddress',
        value: tempClinicAddress,
      });
      setClinicAddress(tempClinicAddress);
      clinicAddressTouchedRef.current = false;
      toast.success(i18n.t('settings.options.toasts.success'));
    } catch (error) {
      console.error('Erro ao salvar endereço da clínica:', error);
      toast.error(i18n.t('settings.options.toasts.error'));
    } finally {
      setLoadingClinicAddress(false);
    }
  }

  function handleIdleTimeLimitChange(value) {
    setTempIdleTimeLimit(value);
  }

  async function handleSaveIdleTimeLimit() {
    setLoadingIdleTimeLimit(true);
    try {
      // Obter o ID da empresa do localStorage
      const companyId = localStorage.getItem('companyId');

      if (!companyId) {
        throw new Error('Company ID not found');
      }

      // Atualizar o idleTimeLimit na empresa
      await api.put(`/companies/${companyId}`, {
        idleTimeLimit: parseInt(tempIdleTimeLimit),
      });

      setIdleTimeLimit(tempIdleTimeLimit);
      toast.success(i18n.t('settings.options.toasts.success'));
    } catch (error) {
      console.error('Erro ao atualizar idleTimeLimit:', error);
      toast.error(i18n.t('settings.options.toasts.error'));
    } finally {
      setLoadingIdleTimeLimit(false);
    }
  }
  return (
    <>
      <Grid spacing={3} container>
        {/* <Grid xs={12} item>
                    <Title>Configurações Gerais</Title>
                </Grid> */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id='ratings-label'>
              {i18n.t('settings.options.fields.ratings.title')}
            </InputLabel>
            <Select
              labelId='ratings-label'
              value={userRating}
              onChange={async e => {
                handleChangeUserRating(e.target.value);
              }}
            >
              <MenuItem value={'disabled'}>
                {i18n.t('settings.options.fields.ratings.disabled')}
              </MenuItem>
              <MenuItem value={'enabled'}>
                {i18n.t('settings.options.fields.ratings.enabled')}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingUserRating && i18n.t('settings.options.updating')}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id='schedule-type-label'>
              {i18n.t('settings.options.fields.expedientManager.title')}
            </InputLabel>
            <Select
              labelId='schedule-type-label'
              value={scheduleType}
              onChange={async e => {
                handleScheduleType(e.target.value);
              }}
            >
              <MenuItem value={'disabled'}>
                {i18n.t('settings.options.fields.disabled')}
              </MenuItem>
              <MenuItem value={'queue'}>
                {i18n.t('settings.options.fields.expedientManager.queue')}
              </MenuItem>
              <MenuItem value={'company'}>
                {i18n.t('settings.options.fields.expedientManager.company')}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingScheduleType && i18n.t('settings.options.updating')}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id='group-type-label'>
              {i18n.t('settings.options.fields.ignoreMessages.title')}
            </InputLabel>
            <Select
              labelId='group-type-label'
              value={CheckMsgIsGroup}
              onChange={async e => {
                handleGroupType(e.target.value);
              }}
            >
              <MenuItem value={'disabled'}>
                {i18n.t('settings.options.fields.disabled')}
              </MenuItem>
              <MenuItem value={'enabled'}>
                {i18n.t('settings.options.fields.active')}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingScheduleType && i18n.t('settings.options.updating')}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id='call-type-label'>
              {i18n.t('settings.options.fields.acceptCall.title')}
            </InputLabel>
            <Select
              labelId='call-type-label'
              value={callType}
              onChange={async e => {
                handleCallType(e.target.value);
              }}
            >
              <MenuItem value={'disabled'}>
                {i18n.t('settings.options.fields.acceptCall.disabled')}
              </MenuItem>
              <MenuItem value={'enabled'}>
                {i18n.t('settings.options.fields.acceptCall.enabled')}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingCallType && i18n.t('settings.options.updating')}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id='chatbot-type-label'>
              {i18n.t('settings.options.fields.chatbotType.title')}
            </InputLabel>
            <Select
              labelId='chatbot-type-label'
              value={chatbotType}
              onChange={async e => {
                handleChatbotType(e.target.value);
              }}
            >
              <MenuItem value={'text'}>
                {i18n.t('settings.options.fields.chatbotType.text')}
              </MenuItem>
              {/*<MenuItem value={"button"}>Botão</MenuItem>*/}
              {/*<MenuItem value={"list"}>Lista</MenuItem>*/}
            </Select>
            <FormHelperText>
              {loadingChatbotType && i18n.t('settings.options.updating')}
            </FormHelperText>
          </FormControl>
        </Grid>
        {/* ENVIAR SAUDAÇÃO AO ACEITAR O TICKET */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id='sendGreetingAccepted-label'>
              {i18n.t('settings.options.fields.sendGreetingAccepted.title')}
            </InputLabel>
            <Select
              labelId='sendGreetingAccepted-label'
              value={SendGreetingAccepted}
              onChange={async e => {
                handleSendGreetingAccepted(e.target.value);
              }}
            >
              <MenuItem value={'disabled'}>
                {i18n.t('settings.options.fields.disabled')}
              </MenuItem>
              <MenuItem value={'enabled'}>
                {i18n.t('settings.options.fields.enabled')}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingSendGreetingAccepted &&
                i18n.t('settings.options.updating')}
            </FormHelperText>
          </FormControl>
        </Grid>
        {/* ENVIAR SAUDAÇÃO AO ACEITAR O TICKET */}

        {/* ENVIAR MENSAGEM DE TRANSFERENCIA DE SETOR/ATENDENTE */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id='sendMsgTransfTicket-label'>
              {i18n.t('settings.options.fields.sendMsgTransfTicket.title')}
            </InputLabel>
            <Select
              labelId='sendMsgTransfTicket-label'
              value={SettingsTransfTicket}
              onChange={async e => {
                handleSettingsTransfTicket(e.target.value);
              }}
            >
              <MenuItem value={'disabled'}>
                {i18n.t('settings.options.fields.disabled')}
              </MenuItem>
              <MenuItem value={'enabled'}>
                {i18n.t('settings.options.fields.enabled')}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingSettingsTransfTicket &&
                i18n.t('settings.options.updating')}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* ENVIAR SAUDAÇÃO QUANDO HOUVER SOMENTE 1 FILA */}
        <Grid xs={12} sm={6} md={4} item>
          <FormControl className={classes.selectContainer}>
            <InputLabel id='sendGreetingMessageOneQueues-label'>
              {i18n.t(
                'settings.options.fields.sendGreetingMessageOneQueues.title'
              )}
            </InputLabel>
            <Select
              labelId='sendGreetingMessageOneQueues-label'
              value={sendGreetingMessageOneQueues}
              onChange={async e => {
                handleSendGreetingMessageOneQueues(e.target.value);
              }}
            >
              <MenuItem value={'disabled'}>
                {i18n.t('settings.options.fields.disabled')}
              </MenuItem>
              <MenuItem value={'enabled'}>
                {i18n.t('settings.options.fields.enabled')}
              </MenuItem>
            </Select>
            <FormHelperText>
              {loadingSendGreetingMessageOneQueues &&
                i18n.t('settings.options.updating')}
            </FormHelperText>
          </FormControl>
        </Grid>

        {/* TEMPO MÁXIMO DE OCIOSIDADE */}
        <Grid xs={12} sm={6} md={4} item>
          <div
            style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}
          >
            <FormControl
              className={classes.selectContainer}
              style={{ flex: 1 }}
            >
              <TextField
                id='idleTimeLimit'
                label={i18n.t('settings.options.fields.idleTimeLimit.title')}
                type='number'
                value={tempIdleTimeLimit}
                onChange={e => handleIdleTimeLimitChange(e.target.value)}
                variant='outlined'
                margin='dense'
                inputProps={{ min: 1, max: 1440 }}
                helperText={i18n.t(
                  'settings.options.fields.idleTimeLimit.description'
                )}
              />
            </FormControl>
            <Button
              variant='contained'
              color='primary'
              onClick={handleSaveIdleTimeLimit}
              disabled={
                loadingIdleTimeLimit || tempIdleTimeLimit === idleTimeLimit
              }
              style={{ marginTop: 8, height: 40, minWidth: '100px' }}
            >
              {loadingIdleTimeLimit ? 'Salvando...' : 'Salvar'}
            </Button>
          </div>
        </Grid>
      </Grid>
      <Grid spacing={3} container>
        <Tabs
          indicatorColor='primary'
          textColor='primary'
          scrollButtons='on'
          variant='scrollable'
          className={classes.tab}
          style={{
            marginBottom: 20,
            marginTop: 20,
          }}
        >
          <Tab label={i18n.t('settings.options.tabs.integrations')} />
        </Tabs>
      </Grid>
      {/*-----------------IXC DESATIVADO 4.6.5-----------------*/}
      {/*<Grid spacing={3} container
        style={{ marginBottom: 10 }}>
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          scrollButtons="on"
          variant="scrollable"
          className={classes.tab}
        >
          <Tab

            label="IXC" />

        </Tabs>
        <Grid xs={12} sm={6} md={6} item>
          <FormControl className={classes.selectContainer}>
            <TextField
              id="ipixc"
              name="ipixc"
              margin="dense"
              label="IP do IXC"
              variant="outlined"
              value={ipixcType}
              onChange={async (e) => {
                handleChangeIPIxc(e.target.value);
              }}
            >
            </TextField>
            <FormHelperText>
              {loadingIpIxcType && i18n.t("settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6} md={6} item>
          <FormControl className={classes.selectContainer}>
            <TextField
              id="tokenixc"
              name="tokenixc"
              margin="dense"
              label="Token do IXC"
              variant="outlined"
              value={tokenixcType}
              onChange={async (e) => {
                handleChangeTokenIxc(e.target.value);
              }}
            >
            </TextField>
            <FormHelperText>
              {loadingTokenIxcType && i18n.t("settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>*/}
      {/*-----------------MK-AUTH DESATIVADO 4.6.5-----------------*/}
      {/*<Grid spacing={3} container
        style={{ marginBottom: 10 }}>
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          scrollButtons="on"
          variant="scrollable"
          className={classes.tab}
        >
          <Tab label="MK-AUTH" />

        </Tabs>
        <Grid xs={12} sm={12} md={4} item>
          <FormControl className={classes.selectContainer}>
            <TextField
              id="ipmkauth"
              name="ipmkauth"
              margin="dense"
              label="Ip Mk-Auth"
              variant="outlined"
              value={ipmkauthType}
              onChange={async (e) => {
                handleChangeIpMkauth(e.target.value);
              }}
            >
            </TextField>
            <FormHelperText>
              {loadingIpMkauthType && i18n.t("settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={12} md={4} item>
          <FormControl className={classes.selectContainer}>
            <TextField
              id="clientidmkauth"
              name="clientidmkauth"
              margin="dense"
              label="Client Id"
              variant="outlined"
              value={clientidmkauthType}
              onChange={async (e) => {
                handleChangeClientIdMkauth(e.target.value);
              }}
            >
            </TextField>
            <FormHelperText>
              {loadingClientIdMkauthType && i18n.t("settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={12} md={4} item>
          <FormControl className={classes.selectContainer}>
            <TextField
              id="clientsecretmkauth"
              name="clientsecretmkauth"
              margin="dense"
              label="Client Secret"
              variant="outlined"
              value={clientsecretmkauthType}
              onChange={async (e) => {
                handleChangeClientSecrectMkauth(e.target.value);
              }}
            >
            </TextField>
            <FormHelperText>
              {loadingClientSecrectMkauthType && i18n.t("settings.options.updating")}
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>*/}
      {/*-----------------ASAAS-----------------*/}
      <Grid spacing={3} container style={{ marginBottom: 10 }}>
        <Tabs
          indicatorColor='primary'
          textColor='primary'
          scrollButtons='on'
          variant='scrollable'
          className={classes.tab}
        >
          <Tab label='ASAAS' />
        </Tabs>
        <Grid xs={12} sm={12} md={12} item>
          <FormControl className={classes.selectContainer}>
            <TextField
              id='asaas'
              name='asaas'
              margin='dense'
              label='Token Asaas'
              variant='outlined'
              value={asaasType}
              onChange={async e => {
                handleChangeAsaas(e.target.value);
              }}
            ></TextField>
            <FormHelperText>
              {loadingAsaasType && i18n.t('settings.options.updating')}
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
      {/*-----------------ENDEREÇO DA CLÍNICA-----------------*/}
      <Grid spacing={3} container style={{ marginBottom: 10 }}>
        <Tabs
          indicatorColor='primary'
          textColor='primary'
          scrollButtons='on'
          variant='scrollable'
          className={classes.tab}
        >
          <Tab label='CLÍNICA' />
        </Tabs>
        <Grid xs={12} sm={9} md={10} item>
          <FormControl className={classes.selectContainer}>
            <TextField
              id='clinicAddress'
              name='clinicAddress'
              margin='dense'
              label='Endereço da clínica'
              variant='outlined'
              value={tempClinicAddress}
              onChange={e => {
                clinicAddressTouchedRef.current = true;
                setTempClinicAddress(e.target.value);
              }}
            />
            <FormHelperText>
              Preenche automaticamente a localização ao criar um agendamento.
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={3} md={2} item>
          <Button
            variant='contained'
            color='primary'
            style={{ marginTop: 8 }}
            disabled={
              loadingClinicAddress || tempClinicAddress === clinicAddress
            }
            onClick={handleSaveClinicAddress}
          >
            {loadingClinicAddress
              ? i18n.t('settings.options.updating')
              : 'Salvar'}
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
